import Image from 'next/image'
import * as S from './FootStyle'

const Foot = () => {
    return (
        <S.FootContainer>
            <S.FooterWrapper>
                <Image src='/image/thlogosmall.png' alt='TH Logistics' width={55} height={25} priority />
                <br/>
                TH Logistics Co.,Ltd.
                <br/>
                240,Kintex-ro, Ilsanseo-gu, Gyeonggi-do, Republic of Korea 10391
                <br/>
                T.+82-31-913-2110 F.+82-31-913 -2111 E-mail: thlog@thlog.co.kr
                <br/>
                Copyright ©TH LOGISTICS. All rights reserved.
            </S.FooterWrapper>
        </S.FootContainer>
    )
}

export default Foot;